/**
 * SchemaGroupIdIsEnabledGate
 */
import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectSchemaValue } from '../../../../services/schemas/selectors';

interface Props {
    children: React.Node;
    groupIdIsEnabled: boolean;
}

export class SchemaGroupIdIsEnabledGate extends React.PureComponent<Props> {
    render() {
        const { children, groupIdIsEnabled } = this.props;
        if (!groupIdIsEnabled) return null;
        return children;
    }
}

const mapStateToProps = createStructuredSelector({
    groupIdIsEnabled: makeSelectSchemaValue('groupIdIsEnabled')
});

export default connect(mapStateToProps)(SchemaGroupIdIsEnabledGate);
